import defaultSettings from '@/setting';
import { useDynamicTitle } from '@/utils/http/dynamicTitle';
import { defineStore } from 'pinia';
// crmeb_merchant settings 迁移
const { sideTheme, showSettings, topNav, tagsView, fixedHeader, sidebarLogo, dynamicTitle } = defaultSettings;

const storageSetting = JSON.parse(localStorage.getItem('layout-setting') ?? '{}') || '';

const useSettingsStore = defineStore('settings', {
    state: () => ({
        title: '',
        theme: storageSetting.theme || '#409EFF',
        sideTheme: storageSetting.sideTheme || sideTheme,
        showSettings: showSettings,
        topNav: storageSetting.topNav === undefined ? topNav : storageSetting.topNav,
        tagsView: storageSetting.tagsView === undefined ? tagsView : storageSetting.tagsView,
        fixedHeader: storageSetting.fixedHeader === undefined ? fixedHeader : storageSetting.fixedHeader,
        sidebarLogo: storageSetting.sidebarLogo === undefined ? sidebarLogo : storageSetting.sidebarLogo,
        dynamicTitle: storageSetting.dynamicTitle === undefined ? dynamicTitle : storageSetting.dynamicTitle,
        storeDiy: 1,
        /** 编辑页未保存（对齐 EB settings.isEdit，离开路由时提示） */
        routeEditDirty: false,
    }),
    actions: {
        setRouteEditDirty(dirty: boolean) {
            this.routeEditDirty = dirty;
        },
        // 修改布局设置
        changeSetting(data: any) {
            const { key, value } = data;
            if (this.hasOwnProperty(key)) {
                Reflect.set(this, key, value);
                // this[key] = value;
            }
        },
        // 设置网页标题
        setTitle(title: string) {
            this.title = title;
            useDynamicTitle();
        },
        // 设置 DIY 页面状态
        setStoreDiy(value: number) {
            this.storeDiy = value;
        },
    },
});

export default useSettingsStore;
